import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6657063e")

_pushScopeId("data-v-6657063e")
const _hoisted_1 = { class: "modal-wrap default-modal appointment-modal" }
const _hoisted_2 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "appointmentCreateModel",
  tabindex: "-1",
  "aria-labelledby": "feedbackModalLabel",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "shadowed-card bg-white mb-2 p-3" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "text-success" }
const _hoisted_9 = {
  class: "modal-body",
  id: "appointmentModelScroll"
}
const _hoisted_10 = { class: "form-wrap" }
const _hoisted_11 = { action: "" }
const _hoisted_12 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_13 = { class: "form-group mb-0" }
const _hoisted_14 = { for: "" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_16 = { class: "inline-items" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_20 = { class: "d-flex" }
const _hoisted_21 = { class: "flex-grow-1" }
const _hoisted_22 = { class: "dropdown color-select-wrap mt-2 ml-2" }
const _hoisted_23 = {
  class: "dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = {
  class: "color-eclipse",
  style: {"background-color":"#fdc689"}
}
const _hoisted_26 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_27 = {
  class: "color-eclipse",
  style: {"background-color":"#a3d39c"}
}
const _hoisted_28 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_29 = {
  class: "color-eclipse",
  style: {"background-color":"#f49ac1"}
}
const _hoisted_30 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_31 = {
  class: "color-eclipse",
  style: {"background-color":"#6dcff6"}
}
const _hoisted_32 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_33 = {
  class: "color-eclipse",
  style: {"background-color":"#fbe65d"}
}
const _hoisted_34 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_35 = {
  class: "color-eclipse",
  style: {"background-color":"#cba9f8"}
}
const _hoisted_36 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_37 = {
  class: "color-eclipse",
  style: {"background-color":"#fe7a72"}
}
const _hoisted_38 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_39 = {
  class: "color-eclipse",
  style: {"background-color":"#fc95b8"}
}
const _hoisted_40 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_41 = {
  class: "color-eclipse",
  style: {"background-color":"#10d0cf"}
}
const _hoisted_42 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_43 = {
  class: "color-eclipse",
  style: {"background-color":"#00c489"}
}
const _hoisted_44 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_45 = {
  class: "color-eclipse",
  style: {"background-color":"#73d1b5"}
}
const _hoisted_46 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_47 = {
  class: "color-eclipse",
  style: {"background-color":"#fad1e3"}
}
const _hoisted_48 = {
  key: 0,
  class: "fa fa-check"
}
const _hoisted_49 = { class: "row" }
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = {
  class: "to-upper",
  for: ""
}
const _hoisted_53 = { class: "col-md-6" }
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = {
  class: "to-upper",
  for: ""
}
const _hoisted_56 = { class: "form-group" }
const _hoisted_57 = { for: "allDay" }
const _hoisted_58 = {
  key: 0,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_59 = { class: "form-group mb-0" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { for: "" }
const _hoisted_62 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_63 = { key: 1 }
const _hoisted_64 = { for: "" }
const _hoisted_65 = /*#__PURE__*/_createVNode("input", {
  type: "text",
  class: "form-control",
  placeholder: "www.locationurl.com"
}, null, -1)
const _hoisted_66 = {
  key: 1,
  class: "bg-light p-3 mb-3 rounded"
}
const _hoisted_67 = { class: "form-group mb-0" }
const _hoisted_68 = { class: "form-group to-upper" }
const _hoisted_69 = { for: "location" }
const _hoisted_70 = { class: "bg-light p-3 mb-3 rounded" }
const _hoisted_71 = { class: "form-group mb-0" }
const _hoisted_72 = {
  for: "",
  class: "to-upper"
}
const _hoisted_73 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_74 = { class: "form-group" }
const _hoisted_75 = { for: "" }
const _hoisted_76 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_77 = { class: "form-group" }
const _hoisted_78 = { class: "modal-footer" }
const _hoisted_79 = { class: "form-group" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_GoogleMapAppointment = _resolveComponent("GoogleMapAppointment")
  const _component_Multiselect = _resolveComponent("Multiselect")
  const _component_AddNotification = _resolveComponent("AddNotification")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args))),
                class: "close",
                "aria-label": "Close"
              }, [
                _hoisted_6
              ]),
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t('add_appointment')), 1),
              _createVNode("p", null, [
                _createVNode("small", _hoisted_8, _toDisplayString(_ctx.$t('add_appointment_with_email')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.errorList,
                hasError: _ctx.state.isErrorStatus
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_10, [
                _createVNode("form", _hoisted_11, [
                  _createVNode("div", _hoisted_12, [
                    _createVNode("div", _hoisted_13, [
                      _createVNode("label", _hoisted_14, [
                        _createTextVNode(_toDisplayString(_ctx.$t('meeting_via')) + " ", 1),
                        _hoisted_15
                      ]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.meetingVia, (meeting) => {
                            return (_openBlock(), _createBlock("li", { key: meeting }, [
                              _createVNode("label", null, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  name: "optionsRadios",
                                  id: meeting.name,
                                  value: meeting.value,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.meetingType = $event)),
                                  onChange: ($event: any) => (_ctx.checkLogin(meeting.value))
                                }, null, 40, ["id", "value", "onChange"]), [
                                  [_vModelRadio, _ctx.state.meetingType]
                                ]),
                                _createTextVNode(" " + _toDisplayString(meeting.name), 1)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("label", _hoisted_18, [
                      _createTextVNode(_toDisplayString(_ctx.$t('add_new_appointment_title')) + " ", 1),
                      _hoisted_19
                    ]),
                    _createVNode("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "form-control",
                          placeholder: "title",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.title = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.title]
                        ])
                      ]),
                      _createVNode("div", _hoisted_22, [
                        _createVNode("button", _hoisted_23, [
                          _createVNode("span", {
                            class: "color-eclipse",
                            style: `background-color:${_ctx.state.bgColor}`
                          }, null, 4)
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("a", {
                            class: "dropdown-item color-selected",
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.slotcolorSelector('#fdc689')))
                          }, [
                            _createVNode("span", _hoisted_25, [
                              (_ctx.state.bgColor === '#fdc689')
                                ? (_openBlock(), _createBlock("i", _hoisted_26))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.slotcolorSelector('#a3d39c')))
                          }, [
                            _createVNode("span", _hoisted_27, [
                              (_ctx.state.bgColor === '#a3d39c')
                                ? (_openBlock(), _createBlock("i", _hoisted_28))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.slotcolorSelector('#f49ac1')))
                          }, [
                            _createVNode("span", _hoisted_29, [
                              (_ctx.state.bgColor === '#f49ac1')
                                ? (_openBlock(), _createBlock("i", _hoisted_30))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.slotcolorSelector('#6dcff6')))
                          }, [
                            _createVNode("span", _hoisted_31, [
                              (_ctx.state.bgColor === '#6dcff6')
                                ? (_openBlock(), _createBlock("i", _hoisted_32))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.slotcolorSelector('#fbe65d')))
                          }, [
                            _createVNode("span", _hoisted_33, [
                              (_ctx.state.bgColor === '#fbe65d')
                                ? (_openBlock(), _createBlock("i", _hoisted_34))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.slotcolorSelector('#cba9f8')))
                          }, [
                            _createVNode("span", _hoisted_35, [
                              (_ctx.state.bgColor === '#cba9f8')
                                ? (_openBlock(), _createBlock("i", _hoisted_36))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.slotcolorSelector('#fe7a72')))
                          }, [
                            _createVNode("span", _hoisted_37, [
                              (_ctx.state.bgColor === '#fe7a72')
                                ? (_openBlock(), _createBlock("i", _hoisted_38))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.slotcolorSelector('#fc95b8')))
                          }, [
                            _createVNode("span", _hoisted_39, [
                              (_ctx.state.bgColor === '#fc95b8')
                                ? (_openBlock(), _createBlock("i", _hoisted_40))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.slotcolorSelector('#10d0cf')))
                          }, [
                            _createVNode("span", _hoisted_41, [
                              (_ctx.state.bgColor === '#10d0cf')
                                ? (_openBlock(), _createBlock("i", _hoisted_42))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.slotcolorSelector('#00c489')))
                          }, [
                            _createVNode("span", _hoisted_43, [
                              (_ctx.state.bgColor === '#00c489')
                                ? (_openBlock(), _createBlock("i", _hoisted_44))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.slotcolorSelector('#73d1b5')))
                          }, [
                            _createVNode("span", _hoisted_45, [
                              (_ctx.state.bgColor === '#73d1b5')
                                ? (_openBlock(), _createBlock("i", _hoisted_46))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createVNode("a", {
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.slotcolorSelector('#fad1e3')))
                          }, [
                            _createVNode("span", _hoisted_47, [
                              (_ctx.state.bgColor === '#fad1e3')
                                ? (_openBlock(), _createBlock("i", _hoisted_48))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_49, [
                    _createVNode("div", _hoisted_50, [
                      _createVNode("div", _hoisted_51, [
                        _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('meeting_start_date_time')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.start,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.state.data.range.start = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withId(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createVNode("div", _hoisted_53, [
                      _createVNode("div", _hoisted_54, [
                        _createVNode("label", _hoisted_55, _toDisplayString(_ctx.$t('meeting_end_date_time')), 1),
                        _createVNode(_component_v_date_picker, {
                          modelValue: _ctx.state.data.range.end,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.state.data.range.end = $event)),
                          mode: "dateTime"
                        }, {
                          default: _withId(({ inputValue, inputEvents }) => [
                            _createVNode("input", _mergeProps({
                              class: "px-2 py-1 border rounded focus:outline-none focus:border-blue-300",
                              value: inputValue
                            }, _toHandlers(inputEvents)), null, 16, ["value"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_56, [
                    _createVNode("label", _hoisted_57, _toDisplayString(_ctx.$t('all_day')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      id: "allDay",
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.state.allDay = $event))
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.state.allDay]
                    ])
                  ]),
                  (_ctx.state.meetingType == 'skype')
                    ? (_openBlock(), _createBlock("div", _hoisted_58, [
                        _createVNode("div", _hoisted_59, [
                          (_ctx.state.meetingType == 'skype')
                            ? (_openBlock(), _createBlock("div", _hoisted_60, [
                                _createVNode("label", _hoisted_61, _toDisplayString(_ctx.$t('meeting_url_id')), 1),
                                _hoisted_62
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.state.meetingType == 'zoom')
                            ? (_openBlock(), _createBlock("div", _hoisted_63, [
                                _createVNode("label", _hoisted_64, _toDisplayString(_ctx.$t('meeting_code')), 1),
                                _hoisted_65
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.state.meetingType == 'physical')
                    ? (_openBlock(), _createBlock("div", _hoisted_66, [
                        _createVNode("div", _hoisted_67, [
                          _createVNode("div", _hoisted_68, [
                            _createVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('location')), 1),
                            _createVNode(_component_GoogleMapAppointment, {
                              latitude: _ctx.latitude,
                              longitude: _ctx.longitude,
                              location: _ctx.state.location,
                              visible: _ctx.showMap,
                              "onUpdate:latitude": _ctx.updateLatitude,
                              "onUpdate:longitude": _ctx.updateLongitude,
                              "onUpdate:location": _ctx.updateLocation
                            }, null, 8, ["latitude", "longitude", "location", "visible", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:location"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_70, [
                    _createVNode("div", _hoisted_71, [
                      _createVNode("label", _hoisted_72, [
                        _createTextVNode(_toDisplayString(_ctx.$t('invite_user')) + " ", 1),
                        _hoisted_73
                      ]),
                      _createVNode(_component_Multiselect, {
                        taggable: true,
                        modelValue: _ctx.state.data.tags.value,
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.state.data.tags.value = $event)),
                        "tag-placeholder": "Add this as new tag",
                        placeholder: "Search or add a email",
                        mode: "tags",
                        searchable: true,
                        options: _ctx.state.data.tags.options,
                        onTag: _ctx.addTag,
                        createTag: true
                      }, null, 8, ["modelValue", "options", "onTag"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_74, [
                    _createVNode("label", _hoisted_75, [
                      _createTextVNode(_toDisplayString(_ctx.$t('appointment_note')) + " ", 1),
                      _hoisted_76
                    ]),
                    _withDirectives(_createVNode("textarea", {
                      class: "form-control",
                      placeholder: "note if any",
                      rows: "5",
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.state.note = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.state.note]
                    ])
                  ]),
                  _createVNode("div", _hoisted_77, [
                    _createVNode(_component_AddNotification, { onNotificationList: _ctx.updateNotificationList }, null, 8, ["onNotificationList"])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_78, [
              _createVNode("div", _hoisted_79, [
                _createVNode("button", {
                  class: "btn default-btn mr-3",
                  type: "submit",
                  disabled: _ctx.state.postLoadingCreateAppointmen,
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.saveAppointment && _ctx.saveAppointment(...args)))
                }, _toDisplayString(_ctx.state.postLoadingCreateAppointmen ? _ctx.$t('creating') : _ctx.$t('create')), 9, ["disabled"]),
                _createVNode("button", {
                  class: "btn secondary-btn",
                  type: "submit",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.closeAppointmentModal && _ctx.closeAppointmentModal(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.SuccessFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
})